import React, {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useState
} from "react";

import {API_BASE_URL} from "../utils/apiConfig";


const AuthContext = createContext(null);


export const AuthProvider = ({children}) => {

    const [user, setUser] = useState(null);

    const [loading, setLoading] = useState(true);


    const refreshUser = useCallback(async () => {

        try {

            const response = await fetch(
                `${API_BASE_URL}/web-auth/me`,
                {
                    method: "GET",
                    credentials: "include"
                }
            );


            if (!response.ok) {

                setUser(null);

                return null;

            }


            const data = await response.json();


            if (
                data.success &&
                data.authenticated &&
                data.user
            ) {

                setUser(data.user);

                return data.user;

            }


            setUser(null);

            return null;

        } catch (error) {

            console.error(
                "Failed to check authentication:",
                error
            );

            setUser(null);

            return null;

        }

    }, []);


    useEffect(() => {

        const initializeAuth = async () => {

            setLoading(true);

            await refreshUser();

            setLoading(false);

        };


        initializeAuth();

    }, [refreshUser]);


    const logout = useCallback(async () => {

        try {

            await fetch(
                `${API_BASE_URL}/web-auth/logout`,
                {
                    method: "POST",
                    credentials: "include"
                }
            );

        } catch (error) {

            console.error(
                "Logout error:",
                error
            );

        } finally {

            setUser(null);

        }

    }, []);


    const value = {
        user,
        isAuthenticated: !!user,
        loading,
        refreshUser,
        logout
    };


    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );

};


export const useAuth = () => {

    const context = useContext(AuthContext);


    if (!context) {

        throw new Error(
            "useAuth must be used inside AuthProvider"
        );

    }


    return context;

};